'use client'

import { useReportWebVitals } from 'next/web-vitals'

import { isPerfEnabled } from './stats'

const RATING_COLOR: Record<string, string> = {
  good: 'color:#9f9',
  'needs-improvement': 'color:#fc9',
  poor: 'color:#f99',
}

/**
 * Logs Core Web Vitals (LCP, INP, CLS, TTFB, FCP) to the console in dev /
 * when the perf flag is enabled. Values are rounded for readability.
 *
 * Safe to mount in layouts: this component renders nothing.
 */
export function WebVitals() {
  useReportWebVitals((metric) => {
    if (!isPerfEnabled()) return

    const color = RATING_COLOR[metric.rating] ?? 'color:#ccc'
    const value =
      metric.name === 'CLS'
        ? metric.value.toFixed(3)
        : `${Math.round(metric.value)}ms`

    // biome-ignore lint/suspicious/noConsoleLog: dev-only perf diagnostics
    console.log(`%c[web-vitals] ${metric.name} ${value} (${metric.rating})`, color, {
      id: metric.id,
      delta: metric.delta,
      navigationType: metric.navigationType,
    })
  })

  return null
}
